<template>
  <div class="main user-layout-register">
    <h3 style="padding-top:20px;">
      <span style="font-size:26px;color:#000;">会员注册</span>
      <router-link class="login" :to="{ name: 'login' }" style="position:relative;top:16px;font-size:14px;">登录
      </router-link>
    </h3>
    <a-form ref="formRegister" :autoFormCreate="(form)=>{this.form = form}" id="formRegister">
      <!-- <a-form-item
        fieldDecoratorId="companyName"
        :fieldDecoratorOptions="{rules: [{ required: true, message: '用户名不能为空'}, { validator: this.checkUsername }], validateTrigger: ['change', 'blur']}"
      >
        <a-input size="large" type="text" autocomplete="false" placeholder="请输入公司名称(与营业执照上保持一致)"></a-input>
      </a-form-item> -->

      <a-form-item
        fieldDecoratorId="mobile"
        :fieldDecoratorOptions="{rules: [{ required: true, pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号' }, { validator: this.handlePhoneCheck } ],validateTrigger: ['change', 'blur'] }"
      >
        <a-input size="large" placeholder="请输入你的手机号">
          <!-- <a-select slot="addonBefore" size="large" defaultValue="+86">
            <a-select-option value="+86">+86</a-select-option>
            <a-select-option value="+87">+87</a-select-option>
          </a-select>-->
        </a-input>
      </a-form-item>
      <!-- 验证码 -->
      <a-row :gutter="16">
        <a-col class="gutter-row" :span="15">
          <a-form-item
            fieldDecoratorId="captcha"
            :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur'}"
          >
            <a-input size="large" type="text" placeholder="请输入短信验证码">
              <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }"/>
            </a-input>
          </a-form-item>
        </a-col>
        <a-col class="gutter-row" :span="9">
          <a-button
            type="primary"
            class="getCaptcha"
            size="large"
            :disabled="state.smsSendBtn"
            @click.stop.prevent="getCaptcha"
            v-text="!state.smsSendBtn && '获取验证码'||(state.time+' s')"
          ></a-button>
        </a-col>
      </a-row>

      <a-popover placement="rightTop" trigger="click" :visible="state.passwordLevelChecked">
        <template slot="content">
          <div :style="{ width: '240px' }">
            <div :class="['user-register', passwordLevelClass]">
              强度：
              <span>{{ passwordLevelName }}</span>
            </div>
            <a-progress
              :percent="state.percent"
              :showInfo="false"
              :strokeColor=" passwordLevelColor "
            />
            <div style="margin-top: 10px;">
              <span>请至少输入 6-20 个字符。请不要使用容易被猜到的密码。</span>
            </div>
          </div>
        </template>
        <a-form-item
          fieldDecoratorId="password"
          :fieldDecoratorOptions="{rules: [{ required: false}, { validator: this.handlePasswordLevel }], validateTrigger: ['change', 'blur']}"
        >
          <a-input-password
            size="large"
            type="password"
            @click="handlePasswordInputClick"
            autocomplete="false"
            placeholder="至少6-20位密码，区分大小写"
          ></a-input-password>
        </a-form-item>
      </a-popover>

      <a-form-item
        fieldDecoratorId="password2"
        :fieldDecoratorOptions="{rules: [{ required: true, message: '至少6位密码，区分大小写' }, { validator: this.handlePasswordCheck }], validateTrigger: ['change', 'blur']}"
      >
        <a-input-password size="large" type="password" autocomplete="false" placeholder="请再次输入您的密码"></a-input-password>
      </a-form-item>

      <a-form-item
        fieldDecoratorId="realname"
        :fieldDecoratorOptions="{rules: [{ required: true, message: '真实姓名不能为空'}, { validator: this.Arealname }], validateTrigger: ['change', 'blur']}"
      >
        <a-input placeholder="请输入您的真实姓名"/>
      </a-form-item>

      <!-- <a-form-item
        fieldDecoratorId="email"
        :fieldDecoratorOptions="{rules: [{ required: true, type: 'email', message: '请输入正确的邮箱地址' }, { validator: this.handleEmailCheck }], validateTrigger: ['change', 'blur']}"
      >
        <a-input size="large" type="text" placeholder="邮箱"></a-input>
      </a-form-item>-->

      <!--<a-input-group size="large" compact>
            <a-select style="width: 20%" size="large" defaultValue="+86">
              <a-select-option value="+86">+86</a-select-option>
              <a-select-option value="+87">+87</a-select-option>
            </a-select>
            <a-input style="width: 80%" size="large" placeholder="11 位手机号"></a-input>
      </a-input-group>-->

      <!-- <a-row :gutter="16">
        <a-col class="gutter-row" :span="16">
          <a-form-item
            fieldDecoratorId="captcha"
            :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur'}"
          >
            <a-input size="large" type="text" placeholder="验证码">
              <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }"/>
            </a-input>
          </a-form-item>
        </a-col>
        <a-col class="gutter-row" :span="8">
          <a-button
            class="getCaptcha"
            size="large"
            :disabled="state.smsSendBtn"
            @click.stop.prevent="getCaptcha"
            v-text="!state.smsSendBtn && '获取验证码'||(state.time+' s')"
          ></a-button>
        </a-col>
      </a-row>-->

      <!-- 勾选 -->
      <p>
        <!--         <a-checkbox  v-model="check" @click="checkagree()"/>-->
        <!--         <a style="verticalAlign: text-bottom" href="../../assets/Agreement.pdf" target="_blank">&nbsp;&nbsp;阅读并同意《用户服务协议》</a>-->
        <a-checkbox v-model="check" @change="checkagree"></a-checkbox>
        <span style="cursor: pointer" @click="AgreementModel">阅读并同意《用户服务协议》</span>
        <span style="color:#ea0d0da6">{{msgagree}}</span>
      </p>
      <Agreement ref="Agreement"/>
      <a-form-item>
        <a-button
          size="large"
          type="primary"
          htmlType="submit"
          class="register-button"
          :loading="registerBtn"
          @click.stop.prevent="handleSubmit"
          :disabled="registerBtn"
        >立即注册
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { mixinDevice } from '@/utils/mixin.js'
  import { getSmsCaptcha } from '@/api/login'
  import { getAction, postAction } from '@/api/manage'
  import { checkOnlyUser } from '@/api/api'
  import { timeFix } from '@/utils/util'
  import { ACCESS_TOKEN, USER_NAME, USER_INFO, USER_AUTH, SYS_BUTTON_AUTH } from '@/store/mutation-types'
  import Agreement from './Agreement'
  const levelNames = {
    0: '低',
    1: '低',
    2: '中',
    3: '强'
  }
  const levelClass = {
    0: 'error',
    1: 'error',
    2: 'warning',
    3: 'success'
  }
  const levelColor = {
    0: '#ff0000',
    1: '#ff0000',
    2: '#ff7e05',
    3: '#52c41a'
  }
  export default {
    name: 'Register',
    components: {
      Agreement
    },
    mixins: [mixinDevice],
    data() {
      return {
        form: null,
        check: false,
        msgagree: '',
        Arealname: '',
        state: {
          time: 60,
          smsSendBtn: false,
          passwordLevel: 0,
          passwordLevelChecked: false,
          percent: 10,
          progressColor: '#FF0000'
        },
        registerBtn: false
      }
    },
    computed: {
      passwordLevelClass() {
        return levelClass[this.state.passwordLevel]
      },
      passwordLevelName() {
        return levelNames[this.state.passwordLevel]
      },
      passwordLevelColor() {
        return levelColor[this.state.passwordLevel]
      }
    },
    methods: {
      AgreementModel(){
        console.log(this)
        this.$refs.Agreement.Agreementvisible = true
        this.state.passwordLevelChecked = false
      },
      // 勾选
      checkagree() {
        if (this.check) {
          this.msgagree = ''
        } else {
          this.msgagree = '请勾选服务协议'
        }
        return this.check
      },
      // 公司名称
      checkUsername(rule, value, callback) {
        var params = {
          username: value
        }
        checkOnlyUser(params).then(res => {
          if (res.success) {
            callback()
          } else {
            callback('用户名已存在!')
          }
        })
      },
      // Arealname(rule, value, callback) {
      //   var params = {
      //     realname: value
      //   }
      //   checkOnlyUser(params).then(res => {
      //     if (res.success) {
      //       callback()
      //     } else {
      //       callback('姓名已存在')
      //     }
      //   })
      // },
      // handleEmailCheck(rule, value, callback) {
      //   var params = {
      //     email: value
      //   }
      //   checkOnlyUser(params).then(res => {
      //     if (res.success) {
      //       callback()
      //     } else {
      //       callback('邮箱已存在!')
      //     }
      //   })
      // },
      handlePasswordLevel(rule, value, callback) {
        let level = 0
        // let reg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/
        // let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/
        let reg = /^[A-Za-z0-9_]{6,20}$/
        // let reg = /^[0-9]{8,20}$/
        if (!reg.test(value)) {
          console.log(value)
          callback(new Error('密码由6-20位数字、大小写字母组成!'))
        }
        // 判断这个字符串中有没有数字
        if (/[A-Za-z0-9]/.test(value)) {
          level++
        }
        // 判断字符串中有没有字母
        if ((/[a-z]/.test(value)&&/[0-9]/.test(value)||/[A-Z]/.test(value)&&/[0-9]/.test(value)||/[A-Z]/.test(value)&&/[a-z]/.test(value))&&value.length>1) {
          level++
        }
        // 判断字符串中有没有特殊符号
        if (/[a-z]/.test(value)&&value.length>2&&/[A-Z]/.test(value)&&/[0-9]/.test(value)) {
          level++
        }
        this.state.passwordLevel = level
        this.state.percent = level * 30
        if (level >= 2) {
          this.state.percent = level * 30
          if (level >= 3) {
            this.state.percent = 100
          }
        } else {
          if (level === 0) {
            this.state.percent = 10
          }
          // callback(new Error('密码强度不够'))
        }
        callback()
      },

      handlePasswordCheck(rule, value, callback) {
        let password = this.form.getFieldValue('password')
        //console.log('value', value)
        if (value === undefined) {
          callback(new Error('请输入密码'))
        }
        if (value && password && value.trim() !== password.trim()) {
          callback(new Error('两次密码不一致'))
        }
        callback()
      },

      handlePhoneCheck(rule, value, callback) {
        var params = {
          phone: value
        }
        checkOnlyUser(params).then(res => {
          if (res.success) {
            callback()
          } else {
            callback('手机号已存在!')
          }
        })
      },

      handlePasswordInputClick() {
        if (!this.isMobile()) {
          this.state.passwordLevelChecked = true
          return
        }
        this.state.passwordLevelChecked = false
      },
      // 传参
      handleSubmit() {
        this.form.validateFields((err, values) => {
          if (!err) {
            var register = {
              // companyName: values.companyName,
              password: values.password,
              realname: values.realname,
              phone: values.mobile,
              smscode: values.captcha
            }
            if (this.check == true) {
              postAction('/sys/user/register', register).then(res => {
                if (!res.success) {
                  this.registerFailed(res.message)
                } else {

                  this.$message.success('注册成功')
                  localStorage.setItem('table_state', JSON.stringify(res.result))
                  // this.$router.push({ name: 'registerResult', params: { ...values } })
                  setTimeout(() => {
                    // this.$router.push({name:'login'})
                    this.departConfirm(res)
                  }, 1000)

                }
              })
            } else {
              this.$message.success('请勾选同意协议')
            }
          }
        })
      },

      getCaptcha(e) {
        e.preventDefault()
        let that = this
        this.form.validateFields(['mobile'], { force: true }, (err, values) => {
          if (!err) {
            this.state.smsSendBtn = true
            let interval = window.setInterval(() => {
              if (that.state.time-- <= 0) {
                that.state.time = 60
                that.state.smsSendBtn = false
                window.clearInterval(interval)
              }
            }, 1000)
            const hide = this.$message.loading('验证码发送中..', 0)
            const params = {
              phone: values.mobile,
              code: 'SMS_184365413'
            }
            getAction('/sys/user/verificationVerify', params)
              .then(res => {
                if (!res.success) {
                  this.registerFailed(res.message)
                  setTimeout(hide, 0)
                }
                setTimeout(hide, 500)
              })
              .catch(err => {
                setTimeout(hide, 1)
                clearInterval(interval)
                that.state.time = 60
                that.state.smsSendBtn = false
                this.requestFailed(err)
              })
          }
        })
      },
      registerFailed(message) {
        this.$notification['error']({
          message: '注册失败',
          description: message,
          duration: 2
        })
      },
      requestFailed(err) {
        this.$notification['error']({
          message: '错误',
          description: ((err.response || {}).data || {}).message || '请求出现错误，请稍后再试',
          duration: 4
        })
        this.registerBtn = false
      },
      departConfirm(res) {
        if (res.success) {
          const result = res.result
          const userInfo = result.userInfo
          Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
          Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
          Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
          let multi_depart = res.result.multi_depart
          //0:无部门 1:一个部门 2:多个部门
          if (multi_depart == 0) {
            this.loginSuccess()
            // this.$notification.warn({
            //   message: '提示',
            //   description: `您尚未归属部门,请确认账号信息`,
            //   duration: 3
            // })
          } else if (multi_depart == 2) {
            this.departVisible = true
            this.currentUsername = this.form.getFieldValue('username')
            this.departList = res.result.departs
          } else {
            this.loginSuccess()
          }
        } else {
          this.requestFailed(res)
          // this.Logout()
        }
      },
      loginSuccess() {
        // update-begin- author:sunjianlei --- date:20190812 --- for: 登录成功后不解除禁用按钮，防止多次点击
        // this.loginBtn = false
        // update-end- author:sunjianlei --- date:20190812 --- for: 登录成功后不解除禁用按钮，防止多次点击
        console.log(4444)
        this.$router.push({ name: 'dashboard' })
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`,
          duration: 3
        })
      }
    },
    watch: {
      'state.passwordLevel'(val) {
        console.log(val)
      }
    }
  }
</script>
<style lang="less" scoped>
  .main {
    box-sizing: border-box;
    overflow: hidden;
    padding: 0 30px;
    width: 25%;
    min-width: 400px;
    margin-top: 240px;
    margin-left: 97px;
    background-color: #fff;
  }

  @media screen and (max-width: 1500px) {
    .main {
      margin-top: 205px;
    }
  }

  .user-layout-register {
    .ant-input-group-addon:first-child {
      background-color: #fff;
    }
  }
</style>
<style lang="less" scoped>
  .user-layout-register {
    & > h3 {
      font-size: 18px;
      margin-bottom: 20px;
      font-weight: 700;
    }

    .getCaptcha {
      display: block;
      width: 100%;
      height: 40px;
    }

    .register-button {
      width: 50%;
    }

    .login {
      float: right;
    }

    .login:hover {
      text-decoration: underline;
    }

    .ant-form-item {
      margin-bottom: 15px;
    }

    .ant-input-lg {
      height: 35px;
    }

    /deep/ .ant-form-explain {
      margin-bottom: -10px;
    }
  }
</style>